import { Icon } from '~/shared/ui/Icon/Icon';
import { Typography } from '~/shared/ui/Typography/Typography';

import { useLocalization } from '../../../../localization/localization';

import { Root } from './DiscountMark.ui';

export const DiscountMark = () => {
  const { t } = useLocalization();

  return (
    <Root>
      <Icon name="discount-check" width={16} />
      <Typography.H4>{t('discount mark').toUpperCase()}</Typography.H4>
    </Root>
  );
};
